import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, LockIcon, ZapIcon, HandshakeIcon, MonitorSmartphoneIcon, SmartphoneIcon, CreditCardIcon, FlameIcon, Dice5Icon, CheckIcon, UsersIcon } from 'lucide-react';
import { GlowButton } from './GlowButton';
import { ParticleField } from './ParticleField';
import { trackEvent } from '../lib/pixel';
const MERCADO_PAGO_LOGO = 'https://cdn.magicpatterns.com/uploads/aPiPfoJs7ugEc6jrzQTjqA/descarga_(2).png';
const CHECKOUT_URL = 'https://origenlabonline.shop/cart/46317834797228:1';
const goToCheckout = () => {
  trackEvent('InitiateCheckout', {
    content_name: 'El Juego del Deseo',
    content_category: 'Game',
    value: 19990,
    currency: 'ARS',
    num_items: 1
  });
  window.location.href = CHECKOUT_URL;
};
const ROULETTE_MOCKUP = 'https://cdn.magicpatterns.com/uploads/oLwkG9hCmZ8HTwfxM3cK2K/hacer_la_magen_mas_pro.._202605281127.jpg';
const features = [{
  title: 'Cartas\ndel deseo',
  icon: <svg width="40" height="40" viewBox="0 0 40 40" fill="none" data-id="element-90">
        <rect x="6" y="10" width="18" height="24" rx="2.5" stroke="#FF2D6F" strokeWidth="1.8" fill="rgba(255,45,111,0.05)" data-id="element-91" />
        <rect x="14" y="6" width="18" height="24" rx="2.5" stroke="#FF2D6F" strokeWidth="1.8" fill="rgba(255,45,111,0.08)" data-id="element-92" />
        <path d="M23 14.5c-.8-1.5-3-1.5-3.5 0-.5-1.5-2.7-1.5-3.5 0-.7 1.5.5 3 2 4l1.5 1.3 1.5-1.3c1.5-1 2.7-2.5 2-4z" fill="#FF2D6F" stroke="#FF2D6F" strokeWidth="0.5" data-id="element-93" />
      </svg>
}, {
  title: 'Ruleta\nde la pasión',
  icon: <svg width="40" height="40" viewBox="0 0 40 40" fill="none" data-id="element-94">
        <circle cx="20" cy="20" r="13" stroke="#FF2D6F" strokeWidth="1.8" fill="rgba(255,45,111,0.05)" data-id="element-95" />
        <line x1="20" y1="7" x2="20" y2="33" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-96" />
        <line x1="7" y1="20" x2="33" y2="20" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-97" />
        <line x1="10.8" y1="10.8" x2="29.2" y2="29.2" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-98" />
        <line x1="29.2" y1="10.8" x2="10.8" y2="29.2" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-99" />
        <circle cx="20" cy="20" r="2" fill="#FF2D6F" data-id="element-100" />
      </svg>
}, {
  title: 'Verdad o\natrevimiento',
  icon: <svg width="44" height="40" viewBox="0 0 44 40" fill="none" data-id="element-101">
        <path d="M4 14c0-1.5 1-2.5 2.5-2.5 4 0 8 1.5 11 4 1.5 1 3 1 4.5 0 3-2.5 7-4 11-4 1.5 0 2.5 1 2.5 2.5v6c0 5-4 9-9 9-3 0-5-1.5-6.5-3.5-.8-1-2.2-1-3 0-1.5 2-3.5 3.5-6.5 3.5-5 0-9-4-9-9v-6z" stroke="#FF2D6F" strokeWidth="1.8" fill="rgba(255,45,111,0.06)" strokeLinejoin="round" data-id="element-102" />
        <circle cx="11.5" cy="18" r="1.8" fill="#FF2D6F" data-id="element-103" />
        <circle cx="32.5" cy="18" r="1.8" fill="#FF2D6F" data-id="element-104" />
      </svg>
}, {
  title: 'Configuración\npersonalizada',
  icon: <svg width="40" height="40" viewBox="0 0 40 40" fill="none" data-id="element-105">
        <line x1="6" y1="12" x2="34" y2="12" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-106" />
        <line x1="6" y1="20" x2="34" y2="20" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-107" />
        <line x1="6" y1="28" x2="34" y2="28" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-108" />
        <circle cx="14" cy="12" r="3.2" fill="#000" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-109" />
        <circle cx="26" cy="20" r="3.2" fill="#000" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-110" />
        <circle cx="18" cy="28" r="3.2" fill="#000" stroke="#FF2D6F" strokeWidth="1.8" data-id="element-111" />
      </svg>
}];
const miniBenefits = [{
  icon: HeartIcon,
  title: 'Conexión emocional'
}, {
  icon: FlameIcon,
  title: 'Más diversión y tensión'
}, {
  icon: Dice5Icon,
  title: 'Experiencias diferentes cada vez'
}];
const benefits = [{
  icon: ZapIcon,
  title: 'ACCESO INMEDIATO',
  desc: 'Comenzá a jugar al instante luego de tu compra.'
}, {
  icon: HandshakeIcon,
  title: 'PAGO SEGURO\nCON MERCADO PAGO',
  desc: 'Tus datos y pagos siempre protegidos.'
}, {
  icon: SmartphoneIcon,
  title: 'FUNCIONA EN\nCELULAR Y PC',
  desc: 'Disfrutalo desde donde quieras, cuando quieras.'
}];
const checklistItems = ['Acceso inmediato', 'Compatible con celular y PC', '100% privado', 'Pago único'];
export function Sales() {
  return <motion.div className="relative w-full min-h-screen flex flex-col overflow-hidden bg-black" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} data-id="element-112">
      {/* ATMOSPHERIC BACKGROUND LAYERS */}
      {/* Layer 1: blurred B&W sensual backdrop — brighter & more visible */}
      <motion.div initial={{
      opacity: 0,
      scale: 1.08
    }} animate={{
      opacity: 0.38,
      scale: 1
    }} transition={{
      duration: 2.2,
      ease: 'easeOut'
    }} className="absolute inset-0 z-0 pointer-events-none" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/vSEZzHGLmrPfWdHQeLqDrP/descarga_(5).jpg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center 25%',
      filter: 'grayscale(100%) contrast(1.35) brightness(1.15) blur(2px)'
    }} data-id="element-113" />
      {/* Layer 2: dark readability gradient */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      background: 'linear-gradient(180deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.28) 30%, rgba(0,0,0,0.5) 65%, rgba(0,0,0,0.95) 100%)'
    }} data-id="element-114" />
      {/* Layer 3: cinematic vignette */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(0,0,0,0) 30%, rgba(0,0,0,0.6) 100%)'
    }} data-id="element-115" />
      {/* Layer 4: top pink ambient glow */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 2,
      delay: 0.3
    }} className="absolute top-0 left-1/2 -translate-x-1/2 w-[90vw] max-w-[500px] h-[400px] z-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center top, rgba(255,45,111,0.22) 0%, rgba(255,45,111,0.06) 35%, rgba(0,0,0,0) 70%)',
      filter: 'blur(20px)'
    }} data-id="element-116" />
      {/* Layer 5: bottom red ember glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[100vw] max-w-[600px] h-[260px] z-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center bottom, rgba(185,28,60,0.15) 0%, rgba(0,0,0,0) 65%)',
      filter: 'blur(30px)'
    }} data-id="element-117" />

      <ParticleField data-id="element-118" />

      {/* CONTENT */}
      <div className="relative z-10 max-w-md w-full mx-auto px-6 py-10 flex flex-col" data-id="element-119">
        {/* Heart icon */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.6
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.5,
        type: 'spring'
      }} className="flex justify-center mb-5" data-id="element-120">
          <div className="w-11 h-11 rounded-xl border border-accent-pink/50 flex items-center justify-center" style={{
          boxShadow: '0 0 24px rgba(255,45,111,0.5), inset 0 0 12px rgba(255,45,111,0.15)'
        }} data-id="element-121">
            <HeartIcon className="w-5 h-5 text-accent-pink fill-accent-pink" data-id="element-122" />
          </div>
        </motion.div>

        {/* Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35,
        duration: 0.6
      }} className="text-center space-y-2 mb-3" data-id="element-123">
          <p className="text-xs font-medium text-white/70 tracking-[0.35em] uppercase" data-id="element-124">
            Tu experiencia está
          </p>
          <h1 className="text-6xl md:text-7xl font-display font-bold tracking-[0.08em] text-accent-pink leading-none" style={{
          textShadow: '0 0 30px rgba(255,45,111,0.7), 0 0 60px rgba(255,45,111,0.4), 0 0 90px rgba(255,45,111,0.25)'
        }} data-id="element-125">
            LISTA
          </h1>
        </motion.div>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.55,
        duration: 0.6
      }} className="text-sm text-white/65 text-center leading-relaxed mb-8 max-w-xs mx-auto" style={{
        textShadow: '0 2px 12px rgba(0,0,0,0.8)'
      }} data-id="element-126">
          Accedé a todas las funciones y comenzá a explorar.
        </motion.p>

        {/* 2x2 Feature grid */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.7,
        duration: 0.6
      }} className="grid grid-cols-2 gap-3 mb-8" data-id="element-127">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.8 + index * 0.08,
          duration: 0.4
        }} whileHover={{
          scale: 1.03,
          y: -3
        }} className="relative group" data-id="element-128">
              <div className="absolute -inset-0.5 bg-gradient-to-br from-accent-pink/40 to-accent-red/20 rounded-2xl opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-500" data-id="element-129" />
              <div className="relative h-36 flex flex-col items-center justify-center gap-2.5 rounded-2xl border border-accent-pink/25 overflow-hidden" style={{
            background: 'linear-gradient(135deg, rgba(255,45,111,0.06) 0%, rgba(0,0,0,0.55) 100%)',
            backdropFilter: 'blur(18px) saturate(140%)',
            WebkitBackdropFilter: 'blur(18px) saturate(140%)',
            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06), inset 0 0 30px rgba(255,45,111,0.08), 0 8px 24px rgba(0,0,0,0.45)'
          }} data-id="element-130">
                <div className="absolute inset-0 opacity-50 pointer-events-none" style={{
              background: 'radial-gradient(circle at top left, rgba(255,45,111,0.1) 0%, rgba(0,0,0,0) 65%)'
            }} data-id="element-131" />
                <div className="relative" data-id="element-132">{feature.icon}</div>
                <p className="relative text-[13px] text-white text-center font-medium leading-tight whitespace-pre-line" data-id="element-133">
                  {feature.title}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        {/* PRIMARY CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.1,
        duration: 0.6
      }} className="relative mb-3" data-id="element-134">
          <motion.div className="absolute -inset-4 rounded-full pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(255,45,111,0.45) 0%, rgba(255,45,111,0) 70%)',
          filter: 'blur(22px)'
        }} animate={{
          opacity: [0.6, 1, 0.6],
          scale: [1, 1.06, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-135" />
          <div className="relative" data-id="element-136">
            <GlowButton fullWidth className="py-5 text-base tracking-wide" onClick={goToCheckout} data-id="element-137">
              DESBLOQUEAR MI EXPERIENCIA
            </GlowButton>
          </div>
        </motion.div>

        {/* Price line under primary CTA */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.25,
        duration: 0.5
      }} className="text-center mb-4" data-id="element-138">
          <p className="text-sm text-white/85" style={{
          textShadow: '0 2px 10px rgba(0,0,0,0.85)'
        }} data-id="element-139">
            Acceso completo por{' '}
            <span className="font-bold text-accent-pink" data-id="element-140">$19.990</span>
            <span className="text-white/50" data-id="element-141"> · </span>
            Pago único
            <span className="text-white/50" data-id="element-142"> · </span>
            Sin suscripción
          </p>

          {/* Value-reinforcement perks under price */}
          <div className="mt-4 flex flex-col items-start gap-2 max-w-xs mx-auto text-left" data-id="element-143">
            {[{
            icon: CreditCardIcon,
            text: 'Hasta 3 cuotas con Mercado Pago'
          }, {
            icon: ZapIcon,
            text: 'Acceso inmediato después de la compra'
          }, {
            icon: LockIcon,
            text: 'Pago 100% seguro'
          }, {
            icon: UsersIcon,
            text: 'Se puede jugar en pareja o en grupos de amigos'
          }].map((perk, i) => {
            const Icon = perk.icon;
            return <div key={i} className="flex items-center gap-2.5" data-id="element-144">
                  <Icon className="w-3.5 h-3.5 text-accent-pink flex-shrink-0" strokeWidth={2} data-id="element-145" />
                  <span className="text-[12px] text-white/70 leading-snug" style={{
                textShadow: '0 2px 8px rgba(0,0,0,0.8)'
              }} data-id="element-146">
                    {perk.text}
                  </span>
                </div>;
          })}
          </div>
        </motion.div>

        {/* Small lock line */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.35,
        duration: 0.5
      }} className="flex items-center justify-center gap-2 mb-8" data-id="element-147">
          <LockIcon className="w-3 h-3 text-accent-pink" data-id="element-148" />
          <span className="text-[11px] text-white/55 tracking-wide" style={{
          textShadow: '0 2px 10px rgba(0,0,0,0.8)'
        }} data-id="element-149">
            Compra segura · Datos protegidos
          </span>
        </motion.div>

        {/* Trust badges row */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.4,
        duration: 0.6
      }} className="grid grid-cols-4 gap-2 mb-14" data-id="element-150">
          {/* Badge 1 — 100% Privado */}
          <div className="relative flex flex-col items-center justify-start gap-1.5 px-1.5 py-3 rounded-xl border border-accent-pink/20 overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(255,45,111,0.04) 0%, rgba(0,0,0,0.5) 100%)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          boxShadow: 'inset 0 0 20px rgba(255,45,111,0.06)'
        }} data-id="element-151">
            <LockIcon className="w-4 h-4 text-accent-pink" strokeWidth={1.8} data-id="element-152" />
            <p className="text-[8px] text-white/85 text-center font-semibold leading-tight tracking-wider" data-id="element-153">
              100%{'\n'}PRIVADO
            </p>
          </div>

          {/* Badge 2 — Acceso instantáneo */}
          <div className="relative flex flex-col items-center justify-start gap-1.5 px-1.5 py-3 rounded-xl border border-accent-pink/20 overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(255,45,111,0.04) 0%, rgba(0,0,0,0.5) 100%)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          boxShadow: 'inset 0 0 20px rgba(255,45,111,0.06)'
        }} data-id="element-154">
            <ZapIcon className="w-4 h-4 text-accent-pink" strokeWidth={1.8} data-id="element-155" />
            <p className="text-[8px] text-white/85 text-center font-semibold leading-tight tracking-wider whitespace-pre-line" data-id="element-156">
              ACCESO{'\n'}INSTANTÁNEO
            </p>
          </div>

          {/* Badge 3 — Pago seguro con Mercado Pago */}
          <div className="relative flex flex-col items-center justify-start gap-1 px-1.5 py-3 rounded-xl border border-accent-pink/20 overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(255,45,111,0.04) 0%, rgba(0,0,0,0.5) 100%)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          boxShadow: 'inset 0 0 20px rgba(255,45,111,0.06)'
        }} data-id="element-157">
            <CreditCardIcon className="w-4 h-4 text-accent-pink" strokeWidth={1.8} data-id="element-158" />
            <p className="text-[8px] text-white/85 text-center font-semibold leading-tight tracking-wider" data-id="element-159">
              PAGO{'\n'}SEGURO
            </p>
            <img src={MERCADO_PAGO_LOGO} alt="Mercado Pago" className="h-3 w-auto object-contain mt-0.5" style={{
            filter: 'drop-shadow(0 0 6px rgba(255,255,255,0.15))'
          }} data-id="element-160" />
          </div>

          {/* Badge 4 — Compatible */}
          <div className="relative flex flex-col items-center justify-start gap-1.5 px-1.5 py-3 rounded-xl border border-accent-pink/20 overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(255,45,111,0.04) 0%, rgba(0,0,0,0.5) 100%)',
          backdropFilter: 'blur(14px)',
          WebkitBackdropFilter: 'blur(14px)',
          boxShadow: 'inset 0 0 20px rgba(255,45,111,0.06)'
        }} data-id="element-161">
            <MonitorSmartphoneIcon className="w-4 h-4 text-accent-pink" strokeWidth={1.8} data-id="element-162" />
            <p className="text-[8px] text-white/85 text-center font-semibold leading-tight tracking-wider whitespace-pre-line" data-id="element-163">
              COMPATIBLE{'\n'}CON CUALQUIER{'\n'}DISPOSITIVO
            </p>
          </div>
        </motion.div>

        {/* SECTION — Así se ve por dentro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.5,
        duration: 0.6
      }} className="text-center mb-6" data-id="element-164">
          <h2 className="text-2xl md:text-3xl font-display font-bold tracking-tight mb-2" style={{
          textShadow: '0 0 20px rgba(255,45,111,0.35), 0 2px 14px rgba(0,0,0,0.85)'
        }} data-id="element-165">
            Así se ve por dentro
          </h2>
          <p className="text-sm text-white/65 leading-relaxed max-w-xs mx-auto" style={{
          textShadow: '0 2px 10px rgba(0,0,0,0.8)'
        }} data-id="element-166">
            Más de 300 preguntas, desafíos y experiencias para jugar juntos.
          </p>
        </motion.div>

        {/* iPhone mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.6,
        duration: 0.7
      }} className="relative flex justify-center mb-14" data-id="element-167">
          {/* Ambient halo */}
          <div className="absolute inset-0 -m-8 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(255,45,111,0.25) 0%, rgba(255,45,111,0) 60%)',
          filter: 'blur(30px)'
        }} data-id="element-168" />
          <div className="relative rounded-[2rem] overflow-hidden border border-white/15" style={{
          boxShadow: '0 0 50px rgba(255,45,111,0.25), 0 25px 60px -10px rgba(0,0,0,0.9), inset 0 1px 0 rgba(255,255,255,0.08)'
        }} data-id="element-169">
            <img src={ROULETTE_MOCKUP} alt="Ruleta de la Pasión" className="block w-full max-w-[260px] h-auto" data-id="element-170" />
          </div>
        </motion.div>

        {/* SECTION — Mucho más que un juego */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.7,
        duration: 0.6
      }} className="text-center mb-6" data-id="element-171">
          <h2 className="text-2xl md:text-3xl font-display font-bold tracking-tight mb-3" style={{
          textShadow: '0 0 20px rgba(255,45,111,0.35), 0 2px 14px rgba(0,0,0,0.85)'
        }} data-id="element-172">
            Mucho más que un juego
          </h2>
          <p className="text-sm text-white/65 leading-relaxed max-w-sm mx-auto" style={{
          textShadow: '0 2px 10px rgba(0,0,0,0.8)'
        }} data-id="element-173">
            Creado para parejas que quieren salir de la rutina, generar
            conversaciones diferentes y crear momentos inolvidables.
          </p>
        </motion.div>

        {/* Mini benefits */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.8,
        duration: 0.6
      }} className="grid grid-cols-1 gap-3 mb-14" data-id="element-174">
          {miniBenefits.map((item, index) => {
          const Icon = item.icon;
          return <div key={index} className="relative flex items-center gap-4 px-5 py-4 rounded-2xl border border-accent-pink/20 overflow-hidden" style={{
            background: 'linear-gradient(135deg, rgba(255,45,111,0.06) 0%, rgba(0,0,0,0.5) 100%)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05), 0 6px 20px rgba(0,0,0,0.35)'
          }} data-id="element-175">
                <div className="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center border border-accent-pink/30" style={{
              background: 'linear-gradient(135deg, rgba(255,45,111,0.18) 0%, rgba(0,0,0,0.4) 100%)',
              boxShadow: '0 0 16px rgba(255,45,111,0.3)'
            }} data-id="element-176">
                  <Icon className="w-4 h-4 text-accent-pink" strokeWidth={2} fill={index === 0 ? '#FF2D6F' : 'none'} data-id="element-177" />
                </div>
                <span className="text-sm text-white/90 font-medium" data-id="element-178">
                  {item.title}
                </span>
              </div>;
        })}
        </motion.div>

        {/* HIGHLIGHTED CHECKOUT BOX */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.9,
        duration: 0.6
      }} className="relative mb-6" data-id="element-179">
          {/* Outer glow */}
          <div className="absolute -inset-0.5 rounded-2xl pointer-events-none" style={{
          background: 'linear-gradient(135deg, rgba(255,45,111,0.5) 0%, rgba(185,28,60,0.25) 100%)',
          filter: 'blur(6px)',
          opacity: 0.6
        }} data-id="element-180" />
          <div className="relative rounded-2xl border border-accent-pink/40 p-6 overflow-hidden" style={{
          background: 'linear-gradient(135deg, rgba(255,45,111,0.08) 0%, rgba(0,0,0,0.75) 100%)',
          backdropFilter: 'blur(20px) saturate(140%)',
          WebkitBackdropFilter: 'blur(20px) saturate(140%)',
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08), inset 0 0 40px rgba(255,45,111,0.1), 0 12px 32px rgba(0,0,0,0.5)'
        }} data-id="element-181">
            {/* Inner sheen */}
            <div className="absolute inset-0 opacity-50 pointer-events-none" style={{
            background: 'radial-gradient(circle at top left, rgba(255,45,111,0.12) 0%, rgba(0,0,0,0) 60%)'
          }} data-id="element-182" />

            <p className="relative text-sm text-white/85 leading-relaxed mb-5 text-center" data-id="element-183">
              Lo recibís al instante y podés comenzar a jugar en{' '}
              <span className="font-semibold text-white" data-id="element-184">
                menos de 1 minuto.
              </span>
            </p>

            <div className="relative space-y-3 mb-6" data-id="element-185">
              {checklistItems.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-186">
                  <div className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-pink/20 border border-accent-pink/40 flex items-center justify-center" style={{
                boxShadow: '0 0 10px rgba(255,45,111,0.3)'
              }} data-id="element-187">
                    <CheckIcon className="w-3 h-3 text-accent-pink" strokeWidth={3} data-id="element-188" />
                  </div>
                  <span className="text-sm text-white/85" data-id="element-189">{item}</span>
                </div>)}
            </div>

            {/* Price reminder near checkout */}
            <div className="relative pt-4 border-t border-white/10 text-center" data-id="element-190">
              <p className="text-[11px] text-white/55 tracking-[0.2em] uppercase mb-1" data-id="element-191">
                Acceso completo
              </p>
              <p className="text-3xl font-display font-bold text-accent-pink" style={{
              textShadow: '0 0 24px rgba(255,45,111,0.55), 0 0 50px rgba(255,45,111,0.3)'
            }} data-id="element-192">
                $19.990
              </p>
              <p className="text-[11px] text-white/55 mt-1" data-id="element-193">
                Pago único · Sin suscripción
              </p>
            </div>
          </div>
        </motion.div>

        {/* SECONDARY CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 2,
        duration: 0.6
      }} className="relative mb-4" data-id="element-194">
          <motion.div className="absolute -inset-4 rounded-full pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center, rgba(255,45,111,0.45) 0%, rgba(255,45,111,0) 70%)',
          filter: 'blur(22px)'
        }} animate={{
          opacity: [0.6, 1, 0.6],
          scale: [1, 1.06, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-195" />
          <div className="relative" data-id="element-196">
            <GlowButton fullWidth className="py-5 text-base tracking-wide" onClick={goToCheckout} data-id="element-197">
              DESBLOQUEAR MI EXPERIENCIA
            </GlowButton>
          </div>
        </motion.div>

        {/* Mercado Pago trust line */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 2.1,
        duration: 0.5
      }} className="flex items-center justify-center gap-2 mb-10" data-id="element-198">
          <span className="text-[11px] text-white/55" style={{
          textShadow: '0 2px 10px rgba(0,0,0,0.8)'
        }} data-id="element-199">
            Procesado de forma segura por
          </span>
          <img src={MERCADO_PAGO_LOGO} alt="Mercado Pago" className="h-4 w-auto object-contain" style={{
          filter: 'drop-shadow(0 0 6px rgba(255,255,255,0.15))'
        }} data-id="element-200" />
        </motion.div>

        {/* Benefits row (existing) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 2.2,
        duration: 0.6
      }} className="grid grid-cols-1 gap-6 mb-10" data-id="element-201">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="flex items-start gap-3" data-id="element-202">
                <div className="flex-shrink-0 w-9 h-9 rounded-lg flex items-center justify-center border border-accent-pink/30" style={{
              background: 'linear-gradient(135deg, rgba(255,45,111,0.12) 0%, rgba(0,0,0,0.4) 100%)',
              boxShadow: '0 0 18px rgba(255,45,111,0.25)'
            }} data-id="element-203">
                  <Icon className="w-4 h-4 text-accent-pink" strokeWidth={2} data-id="element-204" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-205">
                  <h4 className="text-[11px] font-bold text-white tracking-wider uppercase leading-tight mb-1 whitespace-pre-line" data-id="element-206">
                    {benefit.title}
                  </h4>
                  <p className="text-[11px] text-white/55 leading-relaxed" data-id="element-207">
                    {benefit.desc}
                  </p>
                </div>
              </div>;
        })}
        </motion.div>

        {/* Bottom microcopy */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 2.4,
        duration: 0.8
      }} className="flex flex-col items-center gap-3 pt-4 pb-2" data-id="element-208">
          <p className="text-[10px] text-white/40 tracking-[0.3em] uppercase text-center" data-id="element-209">
            Experiencias que los acercan. Recuerdos que quedan.
          </p>
          <HeartIcon className="w-4 h-4 text-accent-pink fill-accent-pink" style={{
          filter: 'drop-shadow(0 0 8px rgba(255,45,111,0.7))'
        }} data-id="element-210" />
        </motion.div>
      </div>
    </motion.div>;
}